import React from 'react';
import { KFLSidebarSwitchItem } from '@kamstrup/kamstrup-frontend-library';
import * as DT from '../../../modules/datatable';
import EksKFLWrapper from '../eks-lib/eksKFLwrapper';

interface OwnProps {
  column: DT.TableColumn;
  toggleColumn: (column: DT.TableColumn) => void;
}

type IProps = OwnProps;

const ColumnSetting: React.FC<IProps> = (props: IProps) => {
  return (
    <div className="column__setting">
      <div className="column__title">{props.column.Header}</div>
      <div className="column__visibility">
        {props.column.customizable ? (
          <EksKFLWrapper>
            <KFLSidebarSwitchItem
              id={String(props.column.id)}
              text=""
              tooltip=""
              onClick={() => props.toggleColumn(props.column)}
              isChecked={props.column.show || false}
            />
          </EksKFLWrapper>
        ) : (
          <div>{props.column.show ? 'Always' : 'Never'}</div>
        )}
      </div>
    </div>
  );
};

export default ColumnSetting;
